/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
CampoExtraTextDirectiva.$inject = [];
export default function CampoExtraTextDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-text.html'),
        controller: 'CamposExtraTextCtrl as campExtText',
        bindToController: true
    }
}